import { useEffect, useState } from 'react';
import { useMedplum } from '@medplum/react';
import { useTranslation } from 'react-i18next';
import {
  createInitialReportFormState,
  mapReportToFormState,
} from './report-files.utils';
import { ReportFormState, ReportModalProps } from './report-files.types';

export const useReportFileModal = ({
  opened,
  encounter,
  report,
}: ReportModalProps) => {
  const medplum = useMedplum();
  const { t } = useTranslation(['files-tab', 'patient-pages']);

  const [formState, setFormState] = useState<ReportFormState>(() =>
    report
      ? mapReportToFormState(report)
      : createInitialReportFormState(encounter)
  );

  useEffect(() => {
    if (!opened) {
      setFormState(createInitialReportFormState(encounter));
      return;
    }

    setFormState(
      report
        ? mapReportToFormState(report)
        : createInitialReportFormState(encounter)
    );
  }, [opened, report, encounter]);

  return {
    medplum,
    t,
    formState,
    setFormState,
  };
};
